import type { ProfilingStepRequestDto } from '../dto';
import type { ProfilingStepRequest } from '../models';

export const mapProfilingStepRequestToDto = (
  model: ProfilingStepRequest,
): ProfilingStepRequestDto => ({ ...model });
